import { render, staticRenderFns } from "./WBreadcrumbRouter.vue?vue&type=template&id=2088af26&"
import script from "./WBreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./WBreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports